import { render, staticRenderFns } from "./RewardRedemptionSection.vue?vue&type=template&id=8b37ef6a&scoped=true&"
import script from "./RewardRedemptionSection.vue?vue&type=script&setup=true&lang=js&"
export * from "./RewardRedemptionSection.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./RewardRedemptionSection.vue?vue&type=style&index=0&id=8b37ef6a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b37ef6a",
  null
  
)

export default component.exports